module.exports = __webpack_public_path__ + "json/market6-0.json?e673e25823685ef086229a0cd5978768";


//////////////////
// WEBPACK FOOTER
// ./src/assets/packed/market/market6-0.json
// module id = 1267
// module chunks = 3